import * as React from 'react';
import { Icon, iconName } from '../icons/Icons';
import { Flex } from './FlexHelpers';
import { Button } from '../button/Button';
import { AnimatedCollapsibleContent } from '../collapsible/AnimatedCollapsibleContent';


type IconSelectionPanelWithButtonProps = {
    icons:iconName[],
    selectedIcon?:iconName,
    onIconSelected:(icon:iconName)=>void
}
export function IconSelectionPanelWithButton(props:IconSelectionPanelWithButtonProps):JSX.Element
{
    const [showIcons, setShowIcons] = React.useState(false);
    
    return (
        <div>
            <Flex flexDirection="row" gap={8} alignItems='center'>
                <Icon name={props.selectedIcon || 'cancel'} size='small' />
                <Button text="Vælg ikon" variant="outlined" onClick={() => setShowIcons(true)} />
            </Flex>
            <AnimatedCollapsibleContent open={showIcons}>
                <IconSelectionPanel
                    icons={props.icons}
                    selectedIcon={props.selectedIcon as iconName || undefined}
                    onIconSelected={(icon) => {
                        props.onIconSelected(icon)
                        setShowIcons(false);
                    }}
                />
            </AnimatedCollapsibleContent>
        </div>
    )
}


type IconSelectionPanelProps = {
    icons:iconName[],
    selectedIcon?:iconName,
    onIconSelected:(icon:iconName)=>void
}
export function IconSelectionPanel(props:IconSelectionPanelProps):JSX.Element
{
    return (
        <Flex flexDirection='row' gap={16} flexWrap='wrap'>
            {props.icons.map(icon=>
                <div key={icon}>
                    <Button icon={icon}
                        variant={props.selectedIcon === icon ? 'outlined' : 'dimmed'}
                        onClick={() => props.onIconSelected(icon)}
                    />
                </div>
            )}
        </Flex>
    );
}